// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1yXGI","box":"styles_box__2LszU","message":"styles_message__2-__6"};